import { SIDE_BAR_ITEM } from 'app/config/constants';
import { DEVICE_NATURE } from '../constants/constants';
import { ADDRESS_TYPE } from '../constants/form-fields';
import { AddressDTO } from '../model/AddressDTO.model';
import { MenuItemDTO } from '../model/MenuItemDTO.model';

export function isEmptyObject(obj) {
  return !(typeof obj === 'object' && obj != null && Object.keys(obj).length !== 0);
}

export function isEmptyObjectAttributes(obj) {
  return !(typeof obj === 'object' && Object.values(obj).every(attribute => attribute !== undefined && attribute !== null && attribute !== ''));
}

export function isEmptyArray(array) {
  return !(array != null && Array.isArray(array) && array?.length > 0);
}

export function isEmptyString(obj) {
  return !(typeof obj === 'string' && obj != null && Object.keys(obj).length !== 0);
}

export const capitalize = (param: string) => {
  if (param) return param.charAt(0).toUpperCase() + param.slice(1).toLowerCase();
};

export const setBarItemsUrl = (items: any[], data: MenuItemDTO[]): any[] => {
  data.forEach(element => {
    const { label, icon, code } = items?.find(i => i.code === SIDE_BAR_ITEM[element.barItem]);
    element.label = label;
    element.icon = icon;
    element.code = code;
  });
  return data;
};

export const fixStreetNumber = (addressObject) => {
  if (!isEmptyObject(addressObject)) {
    let { streetNumber, address } = addressObject;
    if (!streetNumber) {
      const blankIndex = address?.indexOf(" ");
      if (blankIndex > 0) {
        streetNumber = address?.substring(0, blankIndex);
        if (!isNaN(streetNumber) && (blankIndex + 1 < address?.length)) {
          address = address?.substring(blankIndex + 1);
          addressObject = { ...addressObject, streetNumber, address };
        }
      }
    }
  }
  return addressObject;
}

export const overwriteShippingAddress = (subscriber): any => {
  let addressObject = new AddressDTO();
  if (!isEmptyObject(subscriber?.address)) {
    addressObject = { ...subscriber.address, addressNature: ADDRESS_TYPE.SHIPPING };
  }
  return fixStreetNumber(addressObject);
};

export const getShippingAddress = (subscriber): any => {
  let addressObject = new AddressDTO();
  if (!isEmptyObject(subscriber?.shippingAddress)) {
    addressObject = subscriber.shippingAddress;
  } else if (!isEmptyObject(subscriber?.address)) {
    addressObject = { ...subscriber.address, addressNature: ADDRESS_TYPE.SHIPPING };
  }
  return fixStreetNumber(addressObject);
};

export const getSubscriberAddress = (subscriber): any => {
  let addressObject = new AddressDTO();
  if (!isEmptyObject(subscriber?.address)) {
    addressObject = { ...subscriber.address, addressNature: ADDRESS_TYPE.MAIN };

  } else if (!isEmptyObject(subscriber?.shippingAddress)) {
    addressObject = { ...subscriber.shippingAddress, addressNature: ADDRESS_TYPE.SHIPPING };
  }
  return fixStreetNumber(addressObject);
};

export const getInsuredGoodFeature = (insuredGood, code): any => {
  if (insuredGood?.features) {
    const detail = insuredGood?.features[code];
    return detail;
  } else {
    return null;
  }
};

export function arraysEqual(array1: any[], array2: any[]): boolean {
  for (let i = 0; i < array1.length; i++) {
    if (array1[i] !== array2[i]) {
      return false;
    }
  }
  return true;
}

export function checkFormatSubscriptionNumber(subscriptionNumber: string): boolean {
  const formatSubscriptionNumber = /^([0-9]{12})$/;
  return formatSubscriptionNumber.test(subscriptionNumber);
}

export function containsOnlyNumber(str: string) {
  const re = /^[0-9\b]+$/;
  return str === '' || re.test(str);
}

export function getDeviceNatureByCode(code: string) {
  switch (code) {
    case "1":
      return DEVICE_NATURE.NEW_DEVICE;
      break;
    case "2":
      return DEVICE_NATURE.DEVICE_REFURBISHED_BY_MANUFACTURER;
      break;
    default:
      break;
  }
}

export const getCivilityCode = (title?: string): string => {
  if (!title) return '0'; // Si title est undefined, null ou '', retourne '0'

  switch (title.toUpperCase()) {
    case 'COMPANY': return '3';
    case 'MRS': return '2';
    case 'MR': return '1';
    default: return '0';
  }
};

export function isMobileDevice() {
  let hasTouchScreen = false;

  if ('maxTouchPoints' in navigator) {
    hasTouchScreen = navigator['maxTouchPoints'] > 0;
  } else if ('msMaxTouchPoints' in navigator) {
    hasTouchScreen = navigator['maxTouchPoints'] > 0;
  } else {
    const mQ = matchMedia('(pointer:coarse)');

    if (mQ && mQ.media === '(pointer:coarse)') {
      hasTouchScreen = !!mQ.matches;
    } else if ('orientation' in window) {
      hasTouchScreen = true; // deprecated, but good fallback
    } else {
      // Only as a last resort, fall back to user agent sniffing

      const UA = navigator['userAgent'];

      hasTouchScreen = /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) || /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA);
    }
  }

  return hasTouchScreen;
}

export const noLog = () => {
  console.log = () => { };
  console.error = () => { };
  console.debug = () => { };
}